module.exports = __webpack_public_path__ + "static/media/lead-acid.bb678da8.svg";